var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVtb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VTB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.88 7.08H3.38L4.5 4H20L18.88 7.08ZM18.32 8.58H2.8L1.68 11.68H17.18L18.32 8.58ZM16.64 13.18H1.14L0 16.28H15.5L16.64 13.18Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtb);
export default __webpack_public_path__ + "static/media/vtb.cf3e6079baf9bda116f5f34fa538e338.svg";
export { ForwardRef as ReactComponent };